import React, { Suspense } from 'react'
import HabitatsMap from './components/Map/HabitatsMap';
import SidePanel from '../../components/SidePanel/SidePanel';
import MapAndSidePanelContainer from '../../components/SidePanel/MapAndSidePanelContainer';
import HabitatsSidePanel from './components/HabitatsSidePanel/HabitatsSidePanel';
import HabitatsContextContainer from './HabitatsContextContainer';
import PageContextContainer from '../../App/PageContextContainer';

export default function HabitatsPage() {
    return (
        <PageContextContainer>
            <HabitatsContextContainer>
                <MapAndSidePanelContainer>
                    <HabitatsMap />
                    <Suspense fallback={<></>}>
                        <SidePanel>
                            <></>
                            <HabitatsSidePanel></HabitatsSidePanel>
                        </SidePanel>
                    </Suspense>
                </MapAndSidePanelContainer>
            </HabitatsContextContainer>
        </PageContextContainer>
    )
}